import { useState } from "react";
import { ArrowDown, ArrowUp, Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FieldGrid, move } from "@/components/admin/website/Fields";

export const ListField = ({ f, value, onChange, testId }) => {
  const [open, setOpen] = useState(null);
  const title = (it) => it.title || it.question || it.name || it.caption || it.label || it.url?.split("/").pop() || "Untitled";
  return (
    <div className="space-y-2 border rounded-lg p-2 bg-slate-50/60">
      {value.map((it, i) => (
        <div key={i} className="bg-white border rounded-md" data-testid={`${testId}-item-${i}`}>
          <div className="flex items-center gap-1 px-2 py-1.5">
            <button type="button" className="flex-1 text-left text-sm font-medium truncate" onClick={() => setOpen(open === i ? null : i)} data-testid={`${testId}-item-${i}-toggle`}>{i + 1}. {title(it)}</button>
            <Button type="button" size="icon" variant="ghost" className="h-7 w-7" onClick={() => onChange(move(value, i, -1))}><ArrowUp className="w-3.5 h-3.5" /></Button>
            <Button type="button" size="icon" variant="ghost" className="h-7 w-7" onClick={() => onChange(move(value, i, 1))}><ArrowDown className="w-3.5 h-3.5" /></Button>
            <Button type="button" size="icon" variant="ghost" className="h-7 w-7" onClick={() => onChange(value.filter((_, j) => j !== i))} data-testid={`${testId}-item-${i}-delete`}><Trash2 className="w-3.5 h-3.5" /></Button>
          </div>
          {open === i && <div className="p-3 border-t"><FieldGrid fields={f.fields} data={it} onChange={(d) => onChange(value.map((x, j) => (j === i ? d : x)))} testId={`${testId}-item-${i}`} /></div>}
        </div>
      ))}
      <Button type="button" size="sm" variant="outline" onClick={() => { onChange([...value, { ...f.item }]); setOpen(value.length); }} data-testid={`${testId}-add`}><Plus className="w-3.5 h-3.5 mr-1" />Add</Button>
    </div>
  );
};
